import { ApiClient } from './client/api_client';

class IdeaThemes {
  static async create(themes: any, ideas: any) {
    return await ApiClient.post('/v1/idea/theme', { themes: { themes, ideas } });
  }
}

export { IdeaThemes };
